import { ConfirmationModal, Typography } from 'seagull';
import { CopyLinkForProposalModal } from "../../../../hooks/useOpenCopyLinkModal/CopyLinkForProposalModal";
import { jsx as _jsx } from "react/jsx-runtime";
export const CopyLinksModal = _ref => {
  let {
    recipients,
    dismissModal
  } = _ref;
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    "data-testid": "links-modal",
    title: "Share by link",
    width: "900px",
    content: /*#__PURE__*/_jsx(CopyLinkForProposalModal, {
      info: /*#__PURE__*/_jsx(Typography, {
        align: "left",
        children: "Please note, while the proposal won\u2019t be sent via email, your client will still receive reminders based on your notification settings"
      }),
      recipients: recipients
    }),
    primaryButtonLabel: "Close",
    primaryButtonTestid: "links-modal-close",
    onPrimaryButtonClick: dismissModal,
    onCloseButtonClick: dismissModal
  });
};